/**
 * 計算number array平均
 * @param this
 * @param listToAverage array to average
 * @returns number
 */
export function averageList(listToAverage) {
    return this.summationList(listToAverage) / listToAverage.length;
}
